import React from 'react';
import { Box } from '@mui/material';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import TrustIndicators from '../components/TrustIndicators';
import PainPointsSection from '../components/PainPointsSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorks from '../components/HowItWorks';
import IndustriesSection from '../components/IndustriesSection';
import VoiceSmsSection from '../components/VoiceSmsSection';
import MultiLanguageSection from '../components/MultiLanguageSection';
import CommandCenterSection from '../components/CommandCenterSection';
import PricingSection from '../components/PricingSection';
// import TestimonialsSection from '../components/TestimonialsSection'; // Hidden - no real reviews yet
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <Navbar />
      <HeroSection />
      <TrustIndicators />
      <PainPointsSection />
      <FeaturesSection />
      <HowItWorks />
      <IndustriesSection />
      <VoiceSmsSection />
      <MultiLanguageSection />
      <CommandCenterSection />
      <PricingSection />
      {/* <TestimonialsSection /> */}{/* Hidden - no real reviews yet */}
      <FAQSection />
      <CTASection />
      <Footer />
    </Box>
  );
};

export default HomePage;
